"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZoneNameFormatOptionsValue = exports.MonthFormatOptionsValue = exports.WeekdateFormatOptionsValue = exports.DateFormatOptionsValue = exports.LangType = exports.DatePickerType = void 0;
var DatePickerType;
(function (DatePickerType) {
    DatePickerType["INPUT"] = "input";
})(DatePickerType = exports.DatePickerType || (exports.DatePickerType = {}));
var LangType;
(function (LangType) {
    LangType["EN"] = "en";
    LangType["ES"] = "es";
})(LangType = exports.LangType || (exports.LangType = {}));
var DateFormatOptionsValue;
(function (DateFormatOptionsValue) {
    DateFormatOptionsValue["TWODIGIT"] = "2-digit";
    DateFormatOptionsValue["NUMERIC"] = "numeric";
})(DateFormatOptionsValue = exports.DateFormatOptionsValue || (exports.DateFormatOptionsValue = {}));
var WeekdateFormatOptionsValue;
(function (WeekdateFormatOptionsValue) {
    WeekdateFormatOptionsValue["NARROW"] = "narrow";
    WeekdateFormatOptionsValue["SHORT"] = "short";
    WeekdateFormatOptionsValue["LONG"] = "long";
})(WeekdateFormatOptionsValue = exports.WeekdateFormatOptionsValue || (exports.WeekdateFormatOptionsValue = {}));
var MonthFormatOptionsValue;
(function (MonthFormatOptionsValue) {
    MonthFormatOptionsValue["TWODIGIT"] = "2-digit";
    MonthFormatOptionsValue["NUMERIC"] = "numeric";
    MonthFormatOptionsValue["NARROW"] = "narrow";
    MonthFormatOptionsValue["SHORT"] = "short";
    MonthFormatOptionsValue["LONG"] = "long";
})(MonthFormatOptionsValue = exports.MonthFormatOptionsValue || (exports.MonthFormatOptionsValue = {}));
var TimeZoneNameFormatOptionsValue;
(function (TimeZoneNameFormatOptionsValue) {
    TimeZoneNameFormatOptionsValue["SHORT"] = "short";
    TimeZoneNameFormatOptionsValue["LONG"] = "long";
})(TimeZoneNameFormatOptionsValue = exports.TimeZoneNameFormatOptionsValue || (exports.TimeZoneNameFormatOptionsValue = {}));
//# sourceMappingURL=DatePickerProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/DatePicker/DatePickerProps.js
// module id = 1144
// module chunks = 8